import $ from 'jquery';

require('C:\\Program Files (x86)\\Microsoft VS Code\\bin\\node_modules\\bootstrap\\js\\tooltip.js');
require('C:\\Program Files (x86)\\Microsoft VS Code\\bin\\node_modules\\bootstrap\\js\\popover.js');

export default class TooltipController {
    static init() {
        $(document).ready(() => {
            $('[data-toggle=\'tooltip\']').tooltip();
            $('[data-toggle=\'popover\']').popover();
            if ($('[rel=tooltip]').length) {
                $('[rel=tooltip]').tooltip();
            }
        });
    }
}
